import { useEffect, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import EmptyCargoSVG from "../../../../media/images/icons/empty-cargo";
import { useAppDispatch } from "../../../../hooks/useRedux";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../services/fetcher";
import CustomSelectOption from "../../../components/CustomSelectOption";

import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import { DotLoader } from "react-spinner-overlay";
import { blueGrey } from "@mui/material/colors";
import CompleteCargoCard from "./CompleteCargoCard";
import CustomDatePicker from "../../../components/DatePicker";
import { useFormik } from "formik";
import { toGregorian } from "jalaali-js";
import { Day } from "react-modern-calendar-datepicker";
import { useInView } from "react-intersection-observer";
import { ITrackingDto } from "../../../../types/trackingPage";

export default function BolsTrackingPage() {
  const dispatch = useAppDispatch();

  const theme = useTheme();

  const [bolsList, setBolsList] = useState<ITrackingDto[]>([]);

  const [filterDate, setFilterDate] = useState<Day | null>();

  const [pageCounts, setPageCounts] = useState(0);

  const [pageN, setPageN] = useState(1);

  const { ref, inView } = useInView({
    threshold: 0,
  });

  const formik = useFormik({
    initialValues: {
      pageNr: 1,
      shipStatus: 0,
    },
    onSubmit: (values) => {
      const newValues = { ...values, shipStatus: values.shipStatus || null };

      getDriverNobatHistory(newValues);
    },
  });

  const {
    trigger: getDriverNobatHistory,
    isMutating: isgetDriverNobatHistoryMutting,
  } = useSWRMutation(
    [`/Nobat/GetNobatShipStatusSender`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setBolsList(data.data);
        setPageCounts(data.count);
      },
    }
  );

  const {
    trigger: getDriverNobatHistoryNextPage,
    isMutating: isgetDriverNobatHistoryMuttingNextPage,
  } = useSWRMutation(
    [`/Nobat/GetNobatShipStatusSender`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setBolsList([...bolsList, ...data.data]);
        // setPageCounts(Math.round(data.count / 10));
      },
    }
  );

  useEffect(() => {
    getDriverNobatHistory({
      pageNr: 1,
    });
    //     {
    //   getActiveNobat: false,
    //   nobatStatus: 0,
    //   pageNr: 1,
    // }
  }, []);

  const handleChangeSelectOption = (value: any, type: string) => {
    console.log(type, value);

    setPageN(1);

    setBolsList([]);

    switch (type) {
      case "shipStatus":
        formik.setFieldValue("shipStatus", Number(value) || null);
        formik.handleSubmit();
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (inView && pageCounts > bolsList.length) {
      setPageN((prev) => prev + 1);
    }
  }, [inView]);

  useEffect(() => {
    getDriverNobatHistoryNextPage({
      pageNr: pageN,
      shipStatus: formik.values.shipStatus || null,
    });
  }, [pageN]);
  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 700,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            رهگیری حمل
          </Typography>
        }
        hasScroll={false}
      />

      <Grid
        container
        spacing={2}
        sx={{
          width: "100%",
          paddingX: "8px",
        }}
      >
        <Grid item xs={6}>
          <CustomSelectOption
            type="shipStatus"
            setValue={handleChangeSelectOption}
            value={formik.values.shipStatus?.toString() || "0"}
            // error={companyActivity.error}
            // errorMessage={companyActivity.errorMessage}
            options={[
              {
                value: 1,
                label: "فیلتر",
                disabled: true,
              },
              {
                value: 2,
                label: "رسید نشده",
              },
              {
                value: 5,
                label: "رسید شده",
              },
              {
                value: 0,
                label: "همه موارد",
              },
            ]}
          />
        </Grid>
        <Grid item xs={6}>
          <CustomDatePicker
            value={filterDate || null}
            handleResetDate={() => {
              formik.setFieldValue("bolDate", null);
              setFilterDate(null);

              formik.handleSubmit();
            }}
            // error={
            //   loadingDateFotmik.touched.loadingDate &&
            //   Boolean(loadingDateFotmik.errors.loadingDate)
            // }
            // errorMessage={
            //   loadingDateFotmik.touched.loadingDate &&
            //   loadingDateFotmik.errors.loadingDate
            // }
            onChange={(value) => {
              setPageN(1);

              setBolsList([]);
              if (value) {
                const { gd, gm, gy } = toGregorian(
                  value?.year,
                  value?.month,
                  value?.day
                );
                formik.setFieldValue(
                  "bolDate",
                  new Date(gy, gm - 1, gd + 1).toISOString()
                );
                setFilterDate(value);
              }

              formik.handleSubmit();

              // if (value) {
              //   const { gd, gm, gy } = jalaali.toGregorian(
              //     value?.year,
              //     value?.month,
              //     value?.day
              //   );
              //   loadingDateFotmik.setFieldValue(
              //     "LoadingDate",
              //     `${gy.toString().padStart(4, "0")}-${gm
              //       .toString()
              //       .padStart(2, "0")}-${gd.toString().padStart(2, "0")}`
              //   );
              // }
            }}
            label={"تاریخ بارنامه"}
          />
        </Grid>
      </Grid>

      {isgetDriverNobatHistoryMutting ? (
        <Box
          sx={{
            flex: "1",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              height: "200px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <DotLoader color={theme.palette.primary.main} />
            <Typography>لطفا منتظر باشید...</Typography>
          </Box>
        </Box>
      ) : !bolsList.length ? (
        <Box
          sx={{
            flex: "1",
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            padding: "8px",
            gap: "8px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              height: "200px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <EmptyCargoSVG size={125} color={theme.palette.primary.main} />
            <Typography
              maxWidth={150}
              textAlign={"center"}
              sx={{
                fontWeight: "700",
                color: blueGrey[500],
              }}
            >
              در حال حاضر محموله تکمیل شده ندارید
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "8px",
            gap: "8px",
          }}
        >
          {bolsList.map((item, index) => (
            <>
              <CompleteCargoCard
                ref={index + 1 === pageN * 10 ? ref : null}
                key={item.id}
                billsItem={item}
                setBillsItems={setBolsList}
              />
              {isgetDriverNobatHistoryMuttingNextPage &&
                index === bolsList.length - 1 && (
                  <Box
                    sx={{
                      minHeight: "200px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "16px",
                    }}
                  >
                    <DotLoader color={theme.palette.primary.main} />
                    <Typography>لطفا منتظر باشید...</Typography>
                  </Box>
                )}
            </>
          ))}
        </Box>
      )}
    </>
  );
}
